<p-toggleswitch [formControl]="control" [attr.tabindex]="tabIndex" [disabled]="disabled"></p-toggleswitch>
